module.exports = __webpack_public_path__ + "img/align-justify.35c2f72c.svg";